module.exports = __webpack_public_path__ + "img/TP4200.1a2dd6f1.png";